import { render, staticRenderFns } from "./PlacePartsDelete.vue?vue&type=template&id=ad85cc22&"
import script from "./PlacePartsDelete.vue?vue&type=script&lang=js&"
export * from "./PlacePartsDelete.vue?vue&type=script&lang=js&"
import style0 from "./PlacePartsDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports